import React from 'react'
import Overlay from '../Overlay'
import { useSelector } from 'react-redux'
import { setShowHelp } from '../../redux/auth/actions'
import Collapse from 'antd/lib/collapse'
import Divider from '../Divider'

const styles = {
    container: {
        width: 700,
        maxHeight: '85vh',
        overflow: 'auto',
        // padding: '2em',
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '0.64em',
    },
    body: {
        marginTop: '0.64em',
    },
    footer: {
        textAlign: 'center',
        marginTop: '1em',
    },
    section: {
        marginTop: '0.64em',
        display: 'flex',
        justifyContent: 'space-between',
    },
    column: {
        width: 260,
    },
}

const Panel = Collapse.Panel


const Help = () => {
    const visible = useSelector((state) => state.auth.showHelp)

    const handleClose = () => {
        setShowHelp(false)
    }

    return (
        <Overlay
            onClose={handleClose}
            visible={visible}
            minimal={false}
            headerText={"Help"}
            closebutton={true}
        // background="#EAF8FF"
        >
            <div style={styles.container}>
                <Collapse bordered={true}>
                    <Panel header="Registering/Logging in for the first time?" key="1">
                        <Collapse bordered={true}>
                            <Panel header="Did you receive an email from system@bssnet.com?" key="1-1">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span><b>STEP 1:</b> Login with your email address & the temporary password provided</span>
                                    <span><b>STEP 2:</b> Update to a new password when prompted</span>
                                    <span><i><b>NOTE:</b> Temporary passwords expire after 14 days. If the temporary password has expired, contact your admin(s) or BSS Support to re-invite you to the system</i></span>
                                </div>
                            </Panel>
                            <Panel header="Did your admin send you an email containing a link?" key="1-2">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span><b>STEP 1:</b> Click on the specific Guardian URL link provided inside their email</span>
                                    <span><b>STEP 2:</b> Complete the online form</span>
                                    <span><b>STEP 3:</b> Click the <b>REGISTER</b> button</span>
                                    <span><i><b>NOTE:</b> Registration links can expire after a set duration chosen by your admin.  If you receive a message that the link is expired or invalid, contact your admin(s) to receive a new registration link.</i></span>
                                </div>
                            </Panel>
                        </Collapse>
                    </Panel>
                    <Panel header="Forgot Password?: Reset Password" key="2">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span><b>STEP 1:</b> Click <b>Forgot Password</b></span>
                            <span><b>STEP 2:</b> You will receive a verification code in your email from system@bssnet.com</span>
                            <span><b>STEP 3:</b> Enter the verfication code</span>
                            <span><b>STEP 4:</b> Update to a new password when prompted</span>
                            <span><i><b>NOTE:</b> Follow the steps above.Your admin(s) or BSS support can also manually reset your password, upon request. Once manually reset, you will receive an email from system@bssnet.com & you will be prompted to update your password</i></span>
                        </div>
                    </Panel>
                    <Panel header="Received a “this email exists in the system message” after trying to register via a link?" key="3">
                        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1.32em' }}>
                            <span><b>STEP 1:</b> Check for an email from system@bssnet.com</span>
                            <span><b>STEP 2:</b> Login using your email address & the temporary password provided</span>
                            <span><b>STEP 3:</b> Update to a new password when prompted</span>
                            <span><i><b>NOTE:</b> This error message occurs when a user has already been added directly to the system by an admin & is also trying register via a link. Temporary passwords expire after 14 days. If the temporary password has expired, contact your admin(s) or BSS Support to re-invite you to the system</i></span>
                        </div>
                        <Collapse>
                            <Panel header="Have you logged into the system before?" key="3-1">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span><b>STEP 1:</b> Click <b>Forgot Password</b> to reset your password. You do not need to re-register every year.</span>
                                    <span><b>STEP 2:</b> You will receive a verification code in your email from system@bssnet.com</span>
                                    <span><b>STEP 3:</b> Enter the verfication code</span>
                                    <span><b>STEP 4:</b> Update to a new password when prompted</span>
                                    <span><i><b>NOTE:</b> Follow the steps above. Your admin(s) or BSS support can also manually reset your password, upon request. Once manually reset, you will receive an email from system@bssnet.com & you will be prompted to update your password</i></span>
                                </div>
                            </Panel>
                        </Collapse>
                    </Panel>
                    <Panel header="Received multiple registration links from your admin?" key="4">
                        <p style={{ marginBottom: '1.32em' }}>
                            <i><b>NOTE:</b> Each registration link allows you to register for a predetermined location. Registration links can expire after a set duration chosen by your admin.  If you receive a message that the link is expired or invalid, contact your admin(s) to receive a new registration link.</i>
                        </p>
                        <Collapse bordered={true}>
                            <Panel header="Registering for your first location?" key="4-1">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span><b>STEP 1:</b> Click on the specific Guardian URL link provided inside the email from your admin</span>
                                    <span><b>STEP 2:</b> Complete the online form</span>
                                    <span><b>STEP 3:</b> Click the <b>REGISTER</b> button</span>
                                </div>
                            </Panel>
                            <Panel header="Already have an account & want to register for an additional location?" key="4-2">
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span><b>STEP 1:</b> Click on the link/URL from your admin that is associated with the additional location you would like to register for</span>
                                    <span><b>STEP 2:</b> Toggle directly to <b>LOGIN</b> (Do not complete the online form under Register)</span>
                                    <span><b>STEP 3:</b> Enter your email and the password that you already use to access your BSS Guardian account</span>
                                    <span><b>STEP 4:</b> Complete the online form for the newly displayed location</span>
                                    <span><b>STEP 5:</b> Click <b>UPDATE</b></span>
                                    <span><b>STEP 6:</b> Repeat the steps above for each new link/location</span>
                                    <span><i><b>NOTE:</b> If you fill out the online registration form first, the system will require you to toggle back to <b>LOGIN</b></i></span>
                                </div>
                            </Panel>
                        </Collapse>
                    </Panel>
                    <Panel header="Temporary password OR registration link not working?" key="5">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <span><b>PASSWORDS:</b> Temporary passwords expire after 14 days. Contact your admin(s) or BSS Support to re-invite you to the system</span>
                            <span><b>LINKS:</b> Registration links can expire after a set duration chosen by your admin. If you receive a message that the link is expired or invalid, contact your admin(s) to receive a new registration link.</span>
                        </div>
                    </Panel>
                </Collapse>
                <p style={{ marginTop: '0.64em', textAlign: 'center' }}>
                    Still having trouble? Contact BSS Support at <a href="mailto:support@bssnet.com">support@bssnet.com</a>  or <a href="tel:8003155676">(800) 315-5676</a>
                </p>
            </div>
        </Overlay >
    )
}

export default Help